/* タカハマライフアート 仲介業者法人向けLP — 埋め込み用スクリプト
   グローバルを汚さないよう即時関数で囲み、.tlp-root 配下のみを操作します。 */
(function () {
  function init() {
    var root = document.querySelector('.tlp-root');
    if (!root) return;

    /* スクロール時のフェードイン */
    var targets = root.querySelectorAll('.tlp-reveal:not(.is-visible)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      Array.prototype.forEach.call(targets, function (el) { io.observe(el); });
    } else {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-visible'); });
    }

    /* お客様の声カルーセル */
    var track = root.querySelector('.tlp-voices');
    if (!track) return;
    root.querySelectorAll('[data-tlp-voice-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.children[0];
        if (!card) return;
        var max = track.scrollWidth - track.clientWidth;
        var step = Math.min(card.getBoundingClientRect().width + 20, max);
        var dir = btn.getAttribute('data-tlp-voice-nav') === 'prev' ? -1 : 1;
        var next = Math.max(0, Math.min(max, track.scrollLeft + dir * step));
        track.scrollTo({ left: next, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*!
 * TAKAHAMA LIFE ART / 特殊プリントLP
 * 名前空間: TLASP_LP（グローバルにこの1つだけを定義。他スクリプトと競合しません）
 * 使い方: </body> 直前で <script src="tlasp-lp.js" defer></script>
 *         設定を変える場合は読み込み前に window.TLASP_LP_CONFIG = {...} を定義
 */
(function () {
  'use strict';

  if (window.TLASP_LP) { return; }

  var ROOT_ID = 'tlasp-root';
  var REVEAL_SELECTOR = '.tlasp-reveal';
  var IN_CLASS = 'tlasp-is-in';

  var defaults = {
    /* アクセントカラー（CSS変数 --tlasp-orange / --tlasp-orange-hover を上書き） */
    accentColor: null,
    accentHoverColor: null,
    /* false にするとスクロールアニメーションを無効化（即表示） */
    animate: true,
    /* 表示アニメーションの段差（ms） */
    staggerStep: 70,
    /* 動画URL（空なら HTML に書かれた src / プレースホルダをそのまま使用） */
    heroVideoUrl: '',
    works02VideoUrl: '',
    works03VideoUrl: ''
  };

  function getConfig() {
    var user = window.TLASP_LP_CONFIG || {};
    var out = {};
    for (var k in defaults) { if (Object.prototype.hasOwnProperty.call(defaults, k)) { out[k] = defaults[k]; } }
    for (var j in user) { if (Object.prototype.hasOwnProperty.call(user, j)) { out[j] = user[j]; } }
    return out;
  }

  var TLASP_LP = {
    config: getConfig(),
    _observer: null,
    _initialized: false,

    init: function () {
      if (this._initialized) { return; }
      var root = document.getElementById(ROOT_ID);
      if (!root) { return; }
      this._initialized = true;
      this.config = getConfig();
      this.applyAccent();
      this.applyVideos();
      this.bindReveal();
      this.bindPrefersReducedMotion();
    },

    /* --- アクセントカラー --- */
    applyAccent: function () {
      var root = document.getElementById(ROOT_ID);
      if (!root) { return; }
      if (this.config.accentColor) {
        root.style.setProperty('--tlasp-orange', this.config.accentColor);
      }
      if (this.config.accentHoverColor) {
        root.style.setProperty('--tlasp-orange-hover', this.config.accentHoverColor);
      }
    },

    /* --- 動画差し替え --- */
    applyVideos: function () {
      var map = [
        ['tlasp-hero-video', this.config.heroVideoUrl],
        ['tlasp-works02-video', this.config.works02VideoUrl],
        ['tlasp-works03-video', this.config.works03VideoUrl]
      ];
      for (var i = 0; i < map.length; i++) {
        var url = map[i][1];
        if (!url) { continue; }
        var el = document.getElementById(map[i][0]);
        if (!el) { continue; }
        if (el.tagName === 'VIDEO') {
          el.setAttribute('src', url);
          if (typeof el.load === 'function') { el.load(); }
          var play = el.play();
          if (play && typeof play.catch === 'function') { play.catch(function () {}); }
        }
      }
    },

    /* --- スクロール表示アニメーション --- */
    bindReveal: function () {
      var root = document.getElementById(ROOT_ID);
      if (!root) { return; }
      var targets = root.querySelectorAll(REVEAL_SELECTOR);
      if (!targets.length) { return; }

      if (this.config.animate === false || !('IntersectionObserver' in window)) {
        this.revealAll();
        return;
      }

      var self = this;
      if (!this._observer) {
        this._observer = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              entries[i].target.classList.add(IN_CLASS);
              self._observer.unobserve(entries[i].target);
            }
          }
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      }

      var step = this.config.staggerStep;
      for (var i = 0; i < targets.length; i++) {
        var el = targets[i];
        if (el.getAttribute('data-tlasp-bound') === '1') { continue; }
        el.setAttribute('data-tlasp-bound', '1');
        el.style.transitionDelay = (Math.min(i % 4, 3) * step) + 'ms';
        this._observer.observe(el);
      }
    },

    revealAll: function () {
      var root = document.getElementById(ROOT_ID);
      if (!root) { return; }
      var targets = root.querySelectorAll(REVEAL_SELECTOR);
      for (var i = 0; i < targets.length; i++) {
        targets[i].style.transitionDelay = '0ms';
        targets[i].classList.add(IN_CLASS);
      }
    },

    /* --- OSの「視差効果を減らす」設定に追従 --- */
    bindPrefersReducedMotion: function () {
      if (!window.matchMedia) { return; }
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mq.matches) { this.revealAll(); }
    },

    destroy: function () {
      if (this._observer) { this._observer.disconnect(); this._observer = null; }
      this._initialized = false;
    }
  };

  window.TLASP_LP = TLASP_LP;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { TLASP_LP.init(); });
  } else {
    TLASP_LP.init();
  }
})();
